import { render, staticRenderFns } from "./geographic-zone.vue?vue&type=template&id=2a3d72fc&scoped=true"
import script from "./geographic-zone.vue?vue&type=script&lang=js"
export * from "./geographic-zone.vue?vue&type=script&lang=js"
import style0 from "./geographic-zone.vue?vue&type=style&index=0&id=2a3d72fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d72fc",
  null
  
)

export default component.exports